import axios from "../utils/axiosconfig";

const getStores = async (id) => {
  let { data } = await axios.get(`getStoreDetails?storeID=${id}`);
  return data;
};

export { getStores };
